export const pageHeaderSx = {
  px: 2,
  py: 1.5,
  bgcolor: '#fff',
  borderBottom: '1px solid #E0E0E0'
};

export const toolbarSx = {
  mb: 2,
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  flexWrap: 'wrap'
};

export const searchFieldSx = {
  width: 360,
  bgcolor: '#fff',

  '& .MuiOutlinedInput-root': {
    height: 38,
    borderRadius: '4px',
    fontSize: 13
  },

  '& input::placeholder': {
    color: '#757575',
    opacity: 1
  }
};

export const createButtonSx = {
  height: 38,
  px: 2.5,
  bgcolor: '#F8F1E2',
  borderColor: '#EFDCB5',
  borderRadius: '4px',
  color: '#424242',
  fontSize: 12,
  fontWeight: 500,
  textTransform: 'uppercase',

  '&:hover': {
    bgcolor: '#FFF3DC',
    borderColor: '#C58A2A'
  },

  '& .MuiButton-startIcon': {
    mr: 0.5
  }
};

export const chipContainerSx = {
  mb: 1.5,
  display: 'flex',
  gap: 1.2,
  flexWrap: 'wrap'
};

export const tablePaperSx = {
  border: '1px solid #E0E0E0',
  borderRadius: '6px',
  boxShadow: 'none',
  overflow: 'hidden'
};

export const tableContainerSx = {
  overflow: 'hidden',
  borderRadius: 2,
  boxShadow: 'none'
};

export const headCellSx = {
  height: 40,
  padding: '0 18px',
  fontSize: '12px',
  fontWeight: 500,
  color: '#424242',
  backgroundColor: '#FAFAFA',
  borderBottom: '1px solid #E0E0E0',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap'
};

export const bodyCellSx = {
  height: 40,
  padding: '0 18px',
  fontSize: '13px',
  color: '#424242',
  borderBottom: '1px solid #EEEEEE'
};

export const paginationSx = {
  borderTop: '1px solid #EAEAEA',
  backgroundColor: '#F5F5F5',

  '& .MuiToolbar-root': {
    minHeight: 40,
    px: 2
  },

  '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
    fontSize: 13,
    color: '#424242'
  },

  '& .MuiTablePagination-select': {
    fontSize: 13
  },

  '& .MuiSvgIcon-root': {
    fontSize: 20
  }
};


export const bodyRowSx = {
  '&:hover': {
    bgcolor: '#FCF8F2',

    '& .MuiTableCell-root': {
      bgcolor: '#FCF8F2'
    }
  }
};